// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"YR","modalTitleContainer":"ZR","continueButtonContainer":"_R","checkoutSecondaryButton":"aS","checkoutPrimaryButton":"bS"};